module.exports = __webpack_public_path__ + "img/1571b5d.jpg";